import TProgressIndicator from './ProgressIndicator.vue'

export const ProgressIndicator = TProgressIndicator
